import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API




export const getServiciosEnVivo = async (id_turno) => {
    const params = {
        id_turno: id_turno
    }
    try {
        const response = await api.post(`${apiUrl}/monitor/servicios-en-vivo/get-servicios`, params)
        return response;

    }
    catch (error) {
        console.log("error", error);
    }
}
export const getTrazoServiciosEnVivo = async (id_bitacora) => {
    const params = {
        id_bitacora: id_bitacora,
        tiempo_real:'true'
    }
    try {
        const response = await api.post(`${apiUrl}/monitor/servicios-en-vivo/get-trazo`, params)
        return response;

    }
    catch (error) {
        console.log("error", error);
    }
}
export const getUnidadPos = async (id_unidad) => {
   
    try {
        const response = await api.get(`${apiUrl}/monitor/servicios-en-vivo/get-pos-unidad?id_unidad=${id_unidad}`)
        return response;

    }
    catch (error) {
        console.log("error", error);
    }
}
export const getTurnosTodo = async () => {
   
    try {
        const response = await api.get(`${apiUrl}/monitor/getTurnosTodo`)
        return response;

    }
    catch (error) {
        console.log("error", error);
    }
}
export const sendMessageTelegram = async (id_cliente,message) => {
    const params = {
        id_cliente: id_cliente,
        mensaje: message
    }
    console.log(
        params
    );
    
    try {
        const response = await api.post(`${apiUrl}/monitor/servicios-en-vivo/sendTelegram`,params)
        return response;

    }
    catch (error) {
        console.log("error", error);
    }
}